export default __webpack_public_path__ + "55292f7aa343a90168b06854a8183423.png";